import { SchemaWithClient } from '../types/SchemaWithClient';
import { enumItems } from './enumItems';
import { statuses } from './statuses';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { RichTextField } from '../components/Table/fields/RichTextField';
import { SelectField } from '../components/Table/fields/SelectField';
import { DateField } from '../components/Table/fields/DateField';
import { SetField } from '../components/Table/fields/SetField';
import { GroupClient } from '../services/GroupClient';
import { salesPartner } from './salesPartner';
import { SelectFieldWithoutAutocomplete } from '../components/Table/fields/SelectFieldWithoutAutocomplete';
import { SPTextField } from '../components/Table/fields/SPTextField';
import { SPNumberField } from '../components/Table/fields/SPNumberField';
import { SPSelectField } from '../components/Table/fields/SPSelectField';
import { SPSetField } from '../components/Table/fields/SPSetField';
import { SPRichTextField } from '../components/Table/fields/SPRichTextField';
import { SPDateField } from '../components/Table/fields/SPDateField';
import { AccommodationReservation } from '../components/Accommodation/AccommodationReservation';
import { SPTimeField } from '../components/Table/fields/SPTimeField';
import { ActivityReservation } from '../components/Activity/ActivityReservation';
import { GroupFinance } from '../components/LegalAndFinance/GroupFinance';
import { userByRole } from './userByRole';
import { ServiceReservation } from '../components/Group/ServiceReservation';
import { SPSetUserField } from '../components/Table/fields/SPSetUserField';
import { SPListField } from '../components/Table/fields/SPListField';
import {SPSelectWithOutAutocomplete} from "../components/Table/fields/SPSelectWithOutAutocompleteField";
import {SPSelectSalesAgentField} from "../components/Table/fields/SPSelectSalesAgentField";
import {ServiceReservationView} from "../components/ActivityReservations/ServiceReservationView";
import {GroupComment} from "../components/Comment/GroupComment";
import {CustomFieldForGroupGuide} from "../components/Table/fields/CustomFieldForGroupGuide";
import {FileField} from "../components/Table/fields/FileField";
import {SingleFileField} from "../components/Table/fields/SingleFileField";
import {RoadBookField} from "../components/Table/fields/RoadBookField";
import {user} from "./user";
import {SPLinkField} from "../components/Table/fields/SPLinkField";
import {serviceProvider} from "./serviceProvider";
import {SPMinimizedRichTextField} from "../components/Table/fields/SPMinimizedRichTextField";
import {SPDateTimeField} from "../components/Table/fields/SPDateTimeField";
export const group: SchemaWithClient<any> = {
  name: 'Group',
  pluralName: 'Groups',
  showDeleted: true,
  hasSum: true,
  tabs: [
    {
      id: 1,
      label: 'General',
      name: 'general',
    },
    {
      id: 2,
      label: 'Accommodations',
      name: 'bookings',
      type: 'custom',
      renderer: AccommodationReservation,
    },
    {
      id: 2,
      label: 'Reservations',
      name: 'service_reservations',
      type: 'custom',
      renderer: ServiceReservation,
    },
    {
      id: 3,
      label: 'Finance',
      name: 'finances',
      type: 'custom',
      renderer: GroupFinance,
    },
    {
      id: 4,
      label: 'Comments',
      name: 'comments',
      type: 'custom',
      renderer: GroupComment,
      rendererType: 'groups',
    },
  ],
  sections: [
    {
      id: 1,
      width: 12,
      label: 'General Data',
      actions: [
        'group-roadmap-print',
        'group-guide-schedule-button',
        'group-feedback-form-button',
        'group-roadmap-button',
        'group-airport-card-button',
      ],
      name: 'general',
      hasDefaultButtons: true,
      grids: [
        {
          width: 4,
          columns: [
            {
              columnName: 'name',
              name: 'Group Name',
              fieldRenderer: SPTextField,
            },
            {
              columnName: 'status',
              name: 'Status',
              fieldRenderer: SPSelectField.tableAdapter(statuses.group),
            },
            /*  {
              columnName: 'country',
              name: 'Country',
              fieldRenderer: SPSelectField.tableAdapter(enumItems.country),
            },*/
            {
              columnName: 'language',
              name: 'Language',
              fieldRenderer: SPSelectField.tableAdapter(enumItems.language),
            },
            {
              columnName: 'stag_name',
              name: "Stag's Name",
              fieldRenderer: SPTextField,
            },
            {
              columnName: 'first_quotation_date',
              name: 'First Quotation Date',
              fieldRenderer: SPDateField,
            },
            {
              columnName: 'booking_date',
              name: 'Booking Date',
              fieldRenderer: SPDateField,
            },
            {
              columnName: 'guides',
              name: 'Guides',
              fieldRenderer: CustomFieldForGroupGuide,
            },
          ],
        },
        {
          width: 4,
          columns: [
            {
              columnName: 'arrival_date',
              name: 'Arrival Date',
              fieldRenderer: SPDateField,
            },
            {
              grid: true,
              columns: [
                {
                  columnName: 'arrival_flight',
                  name: 'Arrival Flight',
                  fieldRenderer: SPSelectField.tableAdapter(enumItems.flight),
                },
                {
                  columnName: 'arrival_estimated_time',
                  name: 'Estimated Time',
                  fieldRenderer: SPTimeField,
                },
              ],
            },
            {
              columnName: 'departure_date',
              name: 'Departure Date',
              fieldRenderer: SPDateField,
            },
            {
              grid: true,
              columns: [
                {
                  columnName: 'departure_flight',
                  name: 'Departure Flight',
                  fieldRenderer: SPSelectField.tableAdapter(enumItems.flight),
                },
                {
                  columnName: 'departure_estimated_time',
                  name: 'Estimated Time',
                  fieldRenderer: SPTimeField,
                },
              ],
            },
            {
              columnName: 'size',
              name: 'Size',
              fieldRenderer: SPNumberField,
            },
            {
              columnName: 'type',
              name: 'Type',
              fieldRenderer: SPSelectField.tableAdapter(enumItems.groupType),
            },
            {
              columnName: 'phone',
              name: 'Phone',
              fieldRenderer: SPTextField,
            },
            {
              columnName: 'email',
              name: 'Email',
              fieldRenderer: SPTextField,
            },
            {
              name: 'Date Added',
              fieldRenderer: SPDateTimeField,
              columnName: 'date_added',
              readOnly: true,
            },
            {
              name: 'User Added',
              columnName: 'user_added',
              fieldRenderer: SPSelectField.tableAdapter(enumItems.user),
              readOnly: true,
            },
          ],
        },
        {
          width: 4,
          columns: [
            {
              columnName: 'base_currency',
              name: 'Base Currency',
              fieldRenderer: SPSelectWithOutAutocomplete.tableAdapter(enumItems.currency),
            },
            {
              columnName: 'sales_partner',
              name: 'Sales Partner',
              fieldRenderer: SPSelectField.tableAdapter(salesPartner),
            },
            {
              columnName: 'partner_link',
              name: 'Partner Link',
              fieldRenderer: SPMinimizedRichTextField,
            },
            {
              columnName: 'sales_agent',
              name: 'Sales Agent',
              fieldRenderer: SPSelectSalesAgentField.tableAdapter(enumItems.user),
            },
            {
              columnName: 'booking_agent',
              name: 'Booking Agent',
              fieldRenderer: SPSelectField.tableAdapter(enumItems.bookingAgent),
            },
            {
              columnName: 'accommodation_request',
              name: 'Requested Accommodation',
              fieldRenderer: SPSelectField.tableAdapter(enumItems.accommodationRequests),
            },
            {
              columnName: 'notes',
              name: 'Notes',
              fieldRenderer: SPRichTextField,
            },
            {
              columnName: 'roadbook',
              name: 'Roadbook',
              fieldRenderer: RoadBookField,
            },
          ],
        },
      ],
    },
    {
      id: 2,
      width: 8,
      label: 'Accommodations',
      name: 'accommodation_reservations',
      grids: [
        {
          width: 12,
          columns: [
            {
              columnName: 'accommodation_reservations',
              fieldRenderer: AccommodationReservation,
            },
          ],
        },
      ],
    },
    {
      id: 3,
      width: 4,
      label: 'Places Visited',
      name: 'places',
      grids: [
        {
          width: 12,
          columns: [
            {
              columnName: 'bars_visited',
              name: 'Bars',
              fieldRenderer: SPSetField.tableAdapter(enumItems.bar),
            },
            {
              columnName: 'strip_bars_visited',
              name: 'Strip Bars',
              fieldRenderer: SPSetField.tableAdapter(enumItems.stripBar),
            },
            {
              columnName: 'clubs_visited',
              name: 'Clubs',
              fieldRenderer: SPSetField.tableAdapter(enumItems.club),
            },
            {
              columnName: 'restaurants_visited',
              name: 'Restaurants',
              fieldRenderer: SPSetField.tableAdapter(enumItems.restaurant),
            },
          ],
        },
      ],
    },
    {
      id: 4,
      width: 12,
      label: 'Activities',
      name: 'roadmap',
      grids: [
        {
          width: 12,
          columns: [
            {
              columnName: 'activity_reservations',
              fieldRenderer: ActivityReservation,
            },
          ],
        },
      ],
    },
    {
      id: 5,
      width: 12,
      label: 'Reservations',
      name: 'reservations',
      grids: [
        {
          width: 12,
          columns: [
            {
              columnName: 'reservations',
              fieldRenderer: ServiceReservationView,
            },
          ],
        },
      ],
    },
  ],
  breadcrumb: ['Group'],
  columns: {
    name: {
      name: 'Group Name',
      required: false,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
      style: {
        background: '#256861',
        color: '#fff',
      },
    },
    status: {
      name: 'SP',
      nameForSidePane: 'Group Status',
      fieldRenderer: SelectFieldWithoutAutocomplete.tableAdapter(
        statuses.group
      ),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(statuses.group),
      switchboard: true,
      required: false,
      url: statuses.group.client.getAllPath,
      tempSchema: statuses.group,
      fieldType: 'status',
    },
    reservation_status: {
      name: 'S',
      nameForSidePane: 'S',
      fieldRenderer: SelectFieldWithoutAutocomplete.tableAdapter(
        statuses.reservationStatus
      ),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(statuses.reservationStatus),
      switchboard: true,
      required: false,
      url: statuses.reservationStatus.client.getAllPath,
      tempSchema: statuses.reservationStatus,
      fieldType: 'status',
      readOnly: true,
    },
    size: {
      name: 'Size',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      required: false,
    },
    type: {
      name: 'Type',
      fieldRenderer: SelectFieldWithoutAutocomplete.tableAdapter(
        enumItems.groupType
      ),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(enumItems.groupType),
      switchboard: true,
      required: false,
      url: enumItems.groupType.client.getAllPath,
      tempSchema: enumItems.groupType,
      defaultShow: false,
    },
    sales_partner: {
      name: 'Sales Partner',
      fieldRenderer: SelectField.tableAdapter(salesPartner),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(salesPartner),
      switchboard: true,
      required: false,
      url: salesPartner.client.getAllPath,
      tempSchema: salesPartner,
    },
    partner_link: {
      name: 'Partner Link',
      fieldRenderer: RichTextField,
      slidePaneFieldRenderer: SPMinimizedRichTextField,
      fieldType: 'text-link',
    },
    guides: {
      name: 'Guides',
      fieldRenderer: SetField.tableAdapter(userByRole('5')),
      slidePaneFieldRenderer: CustomFieldForGroupGuide,
      slidePaneFieldRendererAddNew: SPSetUserField.tableAdapter(userByRole('5')),
      multiSwitchboard: true,
      url: userByRole('5').client.getAllPath,
      tempSchema: userByRole('5'),
      fieldType: 'guide',
    },
    arrival_date: {
      name: 'Arrival',
      required: true,
      fieldRenderer: DateField,
      slidePaneFieldRenderer: SPDateField,
      fieldType: 'date',
    },
    departure_date: {
      name: 'Departure',
      required: false,
      fieldRenderer: DateField,
      slidePaneFieldRenderer: SPDateField,
      fieldType: 'date',
    },
    arrival_flight: {
      name: 'Arrival Flight',
      fieldRenderer: SelectField.tableAdapter(enumItems.flight),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(enumItems.flight),
      switchboard: true,
      required: false,
      url: enumItems.flight.client.getAllPath,
      tempSchema: enumItems.flight,
    },
    departure_flight: {
      name: 'Departure Flight',
      fieldRenderer: SelectField.tableAdapter(enumItems.flight),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(enumItems.flight),
      switchboard: true,
      required: false,
      url: enumItems.flight.client.getAllPath,
      tempSchema: enumItems.flight,
      defaultShow: false,
    },
    stag_name: {
      name: "Stag's Name",
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
      required: false,
      defaultShow: false,
    },
    accommodation_names: {
      name: 'Accommodation',
      fieldRenderer: SetField.tableAdapter(enumItems.accommodation),
      slidePaneFieldRenderer: SPSetField.tableAdapter(enumItems.accommodation),
      multiSwitchboard: true,
      url: enumItems.accommodation.client.getAllPath,
      tempSchema: enumItems.accommodation,
      fieldType: 'accommodation',
      readOnly: true,
    },
    accommodation_addresses: {
      name: 'Accommodation Addresses',
      fieldRenderer: SetField.tableAdapter(enumItems.accommodation),
      slidePaneFieldRenderer: SPSetField.tableAdapter(enumItems.accommodation),
      multiSwitchboard: true,
      url: enumItems.accommodation.client.getAllPath,
      tempSchema: enumItems.accommodation,
      fieldType: 'accommodation-address',
      readOnly: true,
    },
    accommodation_request: {
      name: 'Requested Accommodation',
      fieldRenderer: SelectField.tableAdapter(enumItems.accommodationRequests),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(enumItems.accommodationRequests),
      switchboard: true,
      url: enumItems.accommodationRequests.client.getAllPath,
      tempSchema: enumItems.accommodationRequests,
    },
    language: {
      name: 'Language',
      fieldRenderer: SelectField.tableAdapter(enumItems.language),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(enumItems.language),
      switchboard: true,
      required: false,
      url: enumItems.language.client.getAllPath,
      tempSchema: enumItems.language,
    },
    phone: {
      name: 'Phone',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    email: {
      name: 'Email',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
      defaultShow: false,
    },
    base_currency: {
      name: 'Base Currency',
      fieldRenderer: SelectField.tableAdapter(enumItems.currency),
      slidePaneFieldRenderer: SPSelectWithOutAutocomplete.tableAdapter(enumItems.currency),
      switchboard: true,
      url: enumItems.currency.client.getAllPath,
      tempSchema: enumItems.currency,
      defaultShow: false,
    },
    accommodation_price: {
      name: 'Accommodation Total',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPListField,
      fieldType: 'costs',
      readOnly: true,
    },
    accommodation_cost: {
      name: 'Accommodation Costs',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPListField,
      fieldType: 'costs',
      readOnly: true,
    },
    group_total: {
      name: 'Group Total',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPListField,
      fieldType: 'costs',
      readOnly: true,
    },
    group_costs: {
      name: 'Group Costs',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPListField,
      fieldType: 'costs',
      readOnly: true,
    },
    profit: {
      name: 'Profit',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPListField,
      fieldType: 'costs',
      readOnly: true,
    },
    booking_agent: {
      name: 'Booking Agent',
      fieldRenderer: SelectField.tableAdapter(userByRole('100')),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(userByRole('100')),
      switchboard: true,
      required: false,
      url: userByRole('100').client.getAllPath,
      tempSchema: userByRole('100'),
      defaultShow: false,
    },
    booking_date: {
      name: 'Booking Date',
      fieldRenderer: DateField,
      slidePaneFieldRenderer: SPDateField,
      fieldType: 'date',
      required: false,
      defaultShow: false,
    },
    first_quotation_date: {
      name: 'First Quotation Date',
      fieldRenderer: DateField,
      slidePaneFieldRenderer: SPDateField,
      fieldType: 'date',
      required: false,
    },
    bars_visited: {
      name: 'Bars Visited',
      fieldRenderer: SetField.tableAdapter(enumItems.bar),
      slidePaneFieldRenderer: SPSetField.tableAdapter(enumItems.bar),
      multiSwitchboard: true,
      required: false,
      url: enumItems.bar.client.getAllPath,
      tempSchema: enumItems.bar,
    },
    clubs_visited: {
      name: 'Clubs Visited',
      fieldRenderer: SetField.tableAdapter(enumItems.club),
      slidePaneFieldRenderer: SPSetField.tableAdapter(enumItems.club),
      multiSwitchboard: true,
      required: false,
      url: enumItems.club.client.getAllPath,
      tempSchema: enumItems.club,
    },
    strip_bars_visited: {
      name: 'Strip Bars Visited',
      fieldRenderer: SetField.tableAdapter(enumItems.stripBar),
      slidePaneFieldRenderer: SPSetField.tableAdapter(enumItems.stripBar),
      multiSwitchboard: true,
      required: false,
      url: enumItems.stripBar.client.getAllPath,
      tempSchema: enumItems.stripBar,
    },
    restaurants_visited: {
      name: 'Restaurants Visited',
      fieldRenderer: SetField.tableAdapter(enumItems.restaurant),
      slidePaneFieldRenderer: SPSetField.tableAdapter(enumItems.restaurant),
      multiSwitchboard: true,
      required: false,
      url: enumItems.restaurant.client.getAllPath,
      tempSchema: enumItems.restaurant,
    },
    user_added: {
      name: 'User Added',
      fieldRenderer: SelectField.tableAdapter(user),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(user),
      switchboard: true,
      readOnly: true,
      url: user.client.getAllPath,
      tempSchema: user,
    },
    date_added: {
      name: 'Date Added',
      fieldRenderer: DateField,
      slidePaneFieldRenderer: SPDateTimeField,
      fieldType: 'dateTime',
      readOnly: true,
    },
    roadbook: {
      name: 'Roadbook',
      fieldRenderer: FileField,
      slidePaneFieldRenderer: RoadBookField,
      fieldType: 'roadbook-file',
      readOnly: true
    },
    notes: {
      name: 'Notes',
      fieldRenderer: RichTextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'editable-textarea',
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  client: new GroupClient(),
  viewTable: 'groups',
  isViewTable: true,
};
